"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var hidden_form_input_list_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/hidden_form_input_list"));
var HiddenFormInputListStore = /** @class */ (function () {
    function HiddenFormInputListStore(props) {
        var _this = this;
        this.component = hidden_form_input_list_1.default;
        this.hiddenFields = [];
        this.getValue = function (key) {
            var _a;
            return (_a = _this.hiddenFields.find(function (_a) {
                var name = _a.name;
                return name === key;
            })) === null || _a === void 0 ? void 0 : _a.value;
        };
        this.addHiddenField = function () {
            var _a;
            var fields = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                fields[_i] = arguments[_i];
            }
            (_a = _this.hiddenFields).push.apply(_a, fields);
        };
        this.replaceHiddenField = function () {
            var fields = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                fields[_i] = arguments[_i];
            }
            var names = fields.map(function (_a) {
                var name = _a.name;
                return name;
            });
            _this.hiddenFields = __spreadArray(__spreadArray([], _this.hiddenFields.filter(function (_a) {
                var name = _a.name;
                return !names.includes(name);
            }), true), fields, true);
        };
        this.hiddenFields = props.hiddenFields || [];
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], HiddenFormInputListStore.prototype, "hiddenFields", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], HiddenFormInputListStore.prototype, "addHiddenField", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], HiddenFormInputListStore.prototype, "replaceHiddenField", void 0);
    return HiddenFormInputListStore;
}());
exports.default = HiddenFormInputListStore;
